
import {
  Usuario,
  FuncaoRPA
} from '../index';


export class FuncaoRPAScript {
  "FuncaoRPAId";
  "Ordem";
  "SeletorSap";
  "Tipo";
  "Variavel";
  "ValorPadrao";
  "Descricao";
  "DataCadastro";
  "UsuarioCadastro";
  "DataAlteracao";
  "UsuarioAlteracao";
  "id";
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  FuncaoRPA;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FuncaoRPAScript`.
   */
  static getModelName() {
    return "FuncaoRPAScript";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FuncaoRPAScript for dynamic purposes.
  **/
  static factory(data) {
    return new FuncaoRPAScript(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'FuncaoRPAScript',
      plural: 'FuncaoRPAScripts',
      path: 'FuncaoRPAScripts',
      properties: {
        "FuncaoRPAId": {
          name: 'FuncaoRPAId',
          type: 'number'
        },
        "Ordem": {
          name: 'Ordem',
          type: 'number'
        },
        "SeletorSap": {
          name: 'SeletorSap',
          type: 'string'
        },
        "Tipo": {
          name: 'Tipo',
          type: 'string'
        },
        "Variavel": {
          name: 'Variavel',
          type: 'string'
        },
        "ValorPadrao": {
          name: 'ValorPadrao',
          type: 'string'
        },
        "Descricao": {
          name: 'Descricao',
          type: 'string'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        FuncaoRPA: {
          name: 'FuncaoRPA',
          type: 'FuncaoRPA',
          model: 'FuncaoRPA'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/FuncaoRPAScript.js